<style>
.img-fluid {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.carousel-inner {
  width: 100%;
  height: 100%;
}

.brand-logo {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  height: 160px;
  background-color: #fff !important;
  /* box-shadow: 0 0 18px 3px #000; */
}
</style>
<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <!-- <h2 class="brand-text text-primary ml-1">Vuexy</h2> -->
        <b-img
          :src="require('@/assets/images/logo/ngerplogo.png')"
          alt="logo"
          width="150px"
          height="135px"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        style="width: 100%; height: 100%"
        class="p-0 d-none d-lg-flex align-items-center"
      >
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center"
          style="width: 100%; height: 100%"
        >
          <b-carousel
            style="width: 100%; height: 100%"
            id=" carousel-interval"
            controls
            indicators
            :interval="3000"
          >
            <b-carousel-slide
              v-for="itemImage in banner"
              :key="itemImage.id"
              :img-src="itemImage"
              style="width: 100%; height: 100%"
            />
          </b-carousel>
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Admin Login 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your admin account
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginForm">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group label="Username" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Username"
                  vid="username"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="Enter your username"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox v-model="rememberMe" @change="handelCheckbox($event)">
                  Remember Me
                </b-form-checkbox>
              </b-form-group>
              <!-- submit buttons -->
              <b-button type="submit" variant="primary" block>
                Sign in
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "axios";
import VueCookies from "vue-cookies";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BCarousel,
  BCarouselSlide,
  BButton,
  BAlert,
  BModal,
  VBTooltip,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { realtimeNotificationService } from "@/services/realtimeNotificationService";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BModal,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    BCarousel,
    BCarouselSlide,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rememberMe: false,
      visible: false,
      status: false,
      password: "",
      userEmail: "",
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      sideImg: require("@/assets/images/pages/login-v2.svg"),
      logo: require("@/assets/images/logo/ngerplogo.png"),

      // validation rules
      required,
      banner: [],
      baseApi: process.env.VUE_APP_APIENDPOINT,
      email,
    };
  },
  created() {
    const rememberedUsername = VueCookies.get("admin_username");
    const rememberedPassword = VueCookies.get("admin_password");

    if (rememberedUsername && rememberedPassword) {
      this.userEmail = rememberedUsername;
      this.password = rememberedPassword;
      this.rememberMe = true;
    }
  },
  mounted() {
    this.getBanner();
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
        return this.sideImg;
      }
      return this.sideImg;
    },
    logoUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.logo = require("@/assets/images/logo/ngerplogo.png");
        return this.logo;
      }
      return this.logo;
    },
  },
  methods: {
    handelClickAgreement(value) {
      if (value == "decline") {
        this.visible = false;
        this.rememberMe = false;
        this.status = false;
      } else if (value == "accept") {
        this.visible = false;
        this.rememberMe = true;
        this.status = true;
      }
    },
    handelCheckbox(e) {
      this.visible = this.rememberMe;
    },
    async getBanner() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/auth/banners`,
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((json) => {
          const data = json.data.data.data;
          data.map((item) => {
            if (item.position == "Login Page") {
              this.banner.push(item.image);
            }
          });
        })
        .catch((error) => console.log(error, "error"));
      if (JSON.stringify(this.banner) == "[]") {
        this.banner.push(this.imgUrl);
      }
    },
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          // Call admin login endpoint directly with axios
          axios({
            method: "POST",
            url: `${this.baseApi}/auth/login/admin`,
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              username: this.userEmail,
              password: this.password,
            },
          })
            .then((response) => {
              if (response.data.token) {
                // Handle different response structures
                // Check if user is in response.data.user or response.data.data[0]
                let user = response.data.user;
                if (!user && response.data.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
                  user = response.data.data[0];
                }

                // Debug: Log the response structure
                console.log('Admin Login response.data:', response.data);
                console.log('Admin Login user object:', user);
                console.log('Admin Login user.original_user_name:', user?.original_user_name);

                useJwt.setToken(response.data.token);
                useJwt.setRefreshToken(response.data.token);

                // Store user data with originalUser if it exists (for impersonation)
                localStorage.setItem("userData", JSON.stringify(user));

                // Also store originalUser separately in localStorage if it exists
                // This ensures persistence across page reloads
                if (user.originalUser) {
                  localStorage.setItem("originalUserData", JSON.stringify(user.originalUser));
                } else if (response.data.originalUser) {
                  localStorage.setItem("originalUserData", JSON.stringify(response.data.originalUser));
                } else if (user.original_user_name) {
                  // Backend uses flat fields: original_user_name, original_user_role
                  // Create originalUser object from flat fields for consistency
                  const originalUserData = {
                    id: user.parent?.id || null,
                    name: user.original_user_name,
                    username: user.parent?.username || null,
                    role: user.original_user_role,
                    fullName: user.original_user_name,
                  };
                  localStorage.setItem("originalUserData", JSON.stringify(originalUserData));
                }

                // Trigger event to update UserDropdown component
                this.$root.$emit('userDataUpdated');

                this.$ability.update([
                  {
                    action: "manage",
                    subject: "all",
                  },
                ]);
                this.$router.replace(getHomeRouteForLoggedInUser(user.role));
                if (this.rememberMe) {
                  VueCookies.set("admin_username", this.userEmail, "30d");
                  VueCookies.set("admin_password", this.password, "30d");
                } else {
                  VueCookies.remove("admin_username");
                  VueCookies.remove("admin_password");
                }
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: `Welcome ${user.name || user.name}`,
                    icon: "CoffeeIcon",
                    variant: "success",
                    text: `You have successfully logged in as ${user.role}. Now you can start to explore!`,
                  },
                });
                realtimeNotificationService.requestPermission();
                location.reload();
              } else {
                if (response.data.status == 404) {
                  alert(response.data.message);
                } else {
                  alert("Your Account has been Blocked Please Contact Admin");
                }
              }
            })
            .catch((error) => {
              console.log(error, "error");
              if (error.response && error.response.data) {
                if (error.response.data.message) {
                  alert(error.response.data.message);
                } else {
                  alert("Invalid username or password. Please try again.");
                }
              } else {
                alert("An error occurred. Please try again.");
              }
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

